import type { RouteRecordRaw } from 'vue-router';

export const reportRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Reports',
    path: 'reports',
    children: [
      {
        name: 'IndicatorByProduct',
        path: 'indicator-by-product',
        component: () =>
          import('@/views/private/reports/IndicatorByProductView.vue'),
      },
      {
        name: 'FollowUpReport',
        path: 'follow-up-report',
        component: () =>
          import('@/views/private/reports/DealProgressReportView.vue'),
      },
    ],
  },
];
